<template>
  <div class="header-container">
    <div class="l-content">
      <el-button
        style="margin-right: 20px"
        icon="el-icon-menu"
        @click="handleMenu"
        size="mini"
      ></el-button>
      <!-- 面包屑 -->
      <!-- <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in tags"  :key="item.path" :to="{ path: '/' }">{{ item.label }}</el-breadcrumb-item>
            </el-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item @click="gotoHome()">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">{{
          item
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="r-content">
      <el-dropdown @command="handleClick">
        <span class="el-dropdown-link">
          <img class="user" src="../assets/images/user.png" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>个人中心（{{ getUserName }}）</el-dropdown-item>
          <el-dropdown-item command="cancel">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
import { clearAuthState, redirectToLogin } from "@/utils/auth";
import { mapState } from "vuex";
import { Message } from "element-ui";
export default {
  data() {
    return {};
  },
  methods: {
    gotoHome() {
      if (this.$route.path !== "/home") {
        this.$router.push("/home");
      }
    },
    handleMenu() {
      this.$store.commit("collapseMenu");
    },
    async handleClick(command) {
      if (command === "cancel") {
        try {
          const response = await api.LOGOUT();
          if (response?.data?.code !== 1) {
            return;
          }
        } catch (error) {
          Message.error(error?.response?.data?.msg || error?.message || "退出登录失败");
          return;
        }
        clearAuthState();
        redirectToLogin();
      }
    },
  },
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabsList,
    }),
    getUserName() {
      return (
        this.$store.state.tab.userName ||
        localStorage.getItem("pUserName") ||
        "暂无"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  padding: 0 20px;
  background-color: #333;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text {
    color: #fff;
    font-size: 14px;
    margin-left: 10px;
  }

  .r-content {
    .user {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .l-content {
    display: flex;
    align-items: center;

    /deep/.el-breadcrumb__item {
      .el-breadcrumb__inner {
        font-weight: normal;

        &.is-link {
          color: #666;
        }
      }

      &:last-child {
        .el-breadcrumb__inner {
          color: #fff;
        }
      }
    }
  }
}
</style>
